module.exports = __webpack_public_path__ + "static/media/financial-awards-2021.d85e2815.png";